import styled from 'styled-components';
import { DESKTOP_BREAKPOINT } from '../../../../utils';

export const Container = styled.div``;

export const Dashboard = styled.div`
	display: grid;
	gap: 24px;
	grid-template-columns: repeat(2, 1fr);
	margin-bottom: 32px;

	@media (max-width: ${DESKTOP_BREAKPOINT}px) {
		flex-direction: column;
	}
`;

export const ActionsContainer = styled.div`
	display: flex;
	gap: 4px;
`;

export const PixContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	height: 100%;
	overflow-wrap: anywhere;

	> p {
		margin-top: 10px;
	}
`;

export const PixCopyPasteConfirm = styled.p`
	color: red;
	font-weight: bold;
`;

export const TableWrapper = styled.div`
	width: 100%;
	overflow-x: auto;
`;

export const TagsContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`;

export const CopiaECola = styled.p`
	border: 1px solid;
`;

export const ButtonContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 16px;
`;

export const PixInstruction = styled.div`
	padding: 32px 20px;
`;
